import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            selectedButton: 'PROFILE',
            companiesPayments: [],
            partnerCompanies: [],
            namesForPartner: LocService.t('label_name_for_partner'),
            customCategory: '',
            isEnableGender: false,
            hiddenColumns: CONFIG_COMPANY.HIDDEN_COLUMNS_USER_TABLE ,
            showUserAdditionalInfo: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO,
            showUserAdditionalInfoLessonUrl: CONFIG_COMPANY.SHOW_USER_ADDITIONAL_INFO_LESSON_URL,
            customCategories: [],
            waitingListStatusSelected: null,
            waitingListStatuses: [
                {
                    id: "ACTIVE",
                    label: LocService.t('label_waiting_list_active_one')
                },
                {
                    id: "IN_WAITING_LIST",
                    label: LocService.t('label_waiting_list_waiting')
                },
                {
                    id: "EXPIRED",
                    label: LocService.t('label_waiting_list_expired')
                },
            ],
            role: '',
            userTypes: [],
            additionalInfo: {
                userInfo: null,
            },
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                role: 'ROLE_USER',
                username: '',
                paidDate: null,
                expireDate: null,
                birthday: null,
                shoesSize: null,
                userInfo: null,
                lessonUrl: null,
                restOfTraining: 0,
                isAcceptTerms: false,
                companyPayment: null,
                partnerCompany: null,
                customCategory: '',
                userType: null,
                gender: null,
                isMainAdmin: null,
                waitingListStatus: null,
            },
            showPartners: false,
            //payments models
            name: '',
            payments: [],
            dates6 : [],
            dates12 : [],
            user: {
                paidMonthsInRow: 0
            },
            has6MonthLoyality: 0,
            has12MonthLoyality: 0,
            loyaltyProgramsEnabled: false,
            loyaltyPrograms: null,
            loyaltyProgramsList: [],
            maxLoyaltyProgram: 0,
            isVisibleWaitingListStatus: false,
        }
    },
    computed : {
        orderedPayments : function () {
            function compare(a,b) {
                if (a.paidDate < b.paidDate)
                    return 1;
                if (a.paidDate > b.paidDate)
                    return -1;
                return 0;
            }
            return this.payments.sort(compare)
        }
    },
    methods: {
        update: update,
        clear: clear,
        loadSaradnici: loadSaradnici,
        deleteSaradnik: deleteSaradnik,
        loadCompanyPartner: loadCompanyPartner,
        seePayments: seePayments,
        resetPassword: resetPassword,
        loadUserInfo: loadUserInfo,
        onTabClicked: onTabClicked,
        getChipClassWaiting: getChipClassWaiting,
        isSelectedWaiting: isSelectedWaiting,
        onClickExpireWaiting: onClickExpireWaiting,
        statusClass: statusClass,
        statusIcon: statusIcon,
        formatDate: formatDate,
        formatDate2: formatDate2,
        addPayment: addPayment,
        loyaltyStyle: loyaltyStyle,
        deletePayment: deletePayment,
        getUser: getUser,
        loadPayments: loadPayments,
        getPaymentClassTd: getPaymentClassTd,
        editPayment: editPayment,
        compare(a,b) {
            if (a.paidDate < b.paidDate)
                return 1;
            if (a.paidDate > b.paidDate)
                return -1;
            return 0;
        }
    },
    beforeMount() {
        this.role = session.getRole();
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        let _self = this;
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.type = this.$route.query.type;
        if(this.type === 'payments'){
            this.selectedButton = 'PAYMENTS'
        }
        this.showPartners = session.getConfig().enablePartnersForRegister == null ? true : session.getConfig().enablePartnersForRegister
        this.customCategory = session.getConfig().customCategory == null ? '' : session.getConfig().customCategory
        if(session.getConfig().customCategories != null){
            this.customCategories = session.getConfig().customCategories.split(";")
        }
        if(CONFIG_COMPANY.USER_TYPES != null){
            this.userTypes = CONFIG_COMPANY.USER_TYPES;
        }
        this.isEnableGender = CONFIG_COMPANY.ENABLE_GENDER != null ? CONFIG_COMPANY.ENABLE_GENDER : false;

        if(session.getConfig().maxCapacityActiveUsers != null && session.getConfig().maxCapacityActiveUsers > 0){
            this.isVisibleWaitingListStatus = true
        }
        this.loadSaradnici();
        this.loadCompanyPartner();
        AdminApiService.getUser(this.$route.query.id)
            .then((response) => {
                _self.model = response.data;
                _self.model.userInfo = "nesto";
                _self.model.paidDate = this.$moment(new Date(_self.model.paidDate * 1000)).format('YYYY-MM-DD')
                _self.model.expireDate = this.$moment(new Date(_self.model.expireDate * 1000)).format('YYYY-MM-DD')
                if(response.data.birthday != null){
                    _self.model.birthday = _self.$moment(new Date(response.data.birthday  * 1000)).format('YYYY-MM-DD')
                }
                _self.waitingListStatusSelected =  response.data.waitingListStatus;

            })
            .catch(error => {

                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
        _self.loadUserInfo();

        //payments
        this.loyaltyProgramsEnabled = session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0;
        this.loyaltyPrograms = session.getConfig().loyaltyPrograms;
        if(session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0){
            let temp = this.loyaltyPrograms.split(";")
            this.loyaltyProgramsList = [];
            temp.forEach(t => {
                this.loyaltyProgramsList.push(parseInt(t));
            })
            this.maxLoyaltyProgram = Math.max(...this.loyaltyProgramsList);
        }
        this.loadPayments()
        this.getUser();

    }
}

function loadUserInfo(){
    if(this.showUserAdditionalInfo !== true) return;
    let _self = this;
    AdminApiService.getUserAdditionalInfo(this.$route.query.id)
        .then((response) => {
            if(response.data != null){
                _self.additionalInfo.userInfo = response.data.userInfo;
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function onTabClicked(tab){
    this.selectedButton = tab
}

function loadCompanyPartner() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.partnerCompanies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function clear() {
    this.model.email = '';
    this.model.name = '';
    this.model.phone = '';
    this.model.surname = '';
    this.model.role = 'ROLE_USER';
    this.model.username = '';
    this.model.paidDate = null;
    this.model.expireDate = null;
    this.model.birthday = null;
    this.model.shoesSize = null;
    this.model.lessonUrl = null;
    this.model.userInfo = null;
    this.model.restOfTraining = 0;
    this.model.companyPayment= null;
    this.model.partnerCompany= null;
    this.model.customCategory= '';
    this.model.userType = null;
    this.model.gender = null;
    this.model.isMainAdmin = null;
    this.model.waitingListStatus = null;
}

function update() {
    this.model.paidDate = this.model.paidDate + 'T00:00:00.000Z';
    this.model.expireDate = this.model.expireDate + 'T00:00:00.000Z';
    this.model.userInfo = this.additionalInfo.userInfo;
    this.model.waitingListStatus = this.waitingListStatusSelected;
    if(this.model.birthday != null){
        this.model.birthday = this.model.birthday + 'T08:00:00.000Z';
    }
    let id = this.id;
    AdminApiService.updateUser(this.model, id)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_user_edited'), 'success')
            this.$router.push('/users')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    let id = this.id;

    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_reset_password_to_user'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.resetUserPassword(id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_password_update'), 'success')
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function loadSaradnici() {
    let _self = this;

    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.companiesPayments = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })


}

function deleteSaradnik(){
    this.model.companyPayment = null;
}

function seePayments(){
    this.$router.push('/payment-user?id=' + this.id + '&name=' +  this.model.name + ' ' +  this.model.surname)
}

//paymetns

function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function loadPayments() {
    let _self = this;

    AdminApiService.getPayment(this.$route.query.id)
        .then((response) => {
            _self.payments = response.data.sort((a,b) => _self.compare(a,b));
            if (_self.payments.length > 0) {
                _self.name = _self.payments[0].name + ' ' + _self.payments[0].surname;
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function addPayment() {
    this.$router.push('/add-payment?id=' + this.id)
}

function deletePayment(id) {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_payment_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deletePayment(id)
            .then((response) => {
                _self.loadPayments()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function getUser(){
    let _self = this;
    AdminApiService.getUser(this.$route.query.id)
        .then((response) => {
            _self.user = response.data;
        })
        .catch(error => {

            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}
function getPaymentClassTd(payment) {
    if(payment.paidMoney <= 0){
        return "background: red;"
    }
}

function editPayment(paymentId) {
    this.$router.push('/edit-payment?id=' + paymentId)
}

function loyaltyStyle(maxItem){
    return this.user.paidMonthsInRow >= maxItem ? 'color: green; font-size: 20px;' : 'color: red;font-size: 20px;'
}

function getChipClassWaiting(item){
    if(this.waitingListStatusSelected === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedWaiting(item){
    return this.waitingListStatusSelected === item.id
}


function onClickExpireWaiting(item){
    if(this.waitingListStatusSelected === item.id){
        this.waitingListStatusSelected = null;
    }else{
        this.waitingListStatusSelected = item.id;
    }
    this.load();
}

function statusClass(status) {
    switch (status) {
        case 'ACTIVE':
            return 'status-active'
        case 'IN_WAITING_LIST':
            return 'status-waiting'
        case 'EXPIRED':
            return 'status-expired'
        default:
            return 'status-expired'
    }
}

function statusIcon(status) {
    switch (status) {
        case 'ACTIVE':
            return 'ti-check'
        case 'IN_WAITING_LIST':
            return 'ti-time'
        case 'EXPIRED':
            return 'ti-close'
        default:
            return 'ti-close'
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/UserProfile/UserProfile.js